import {gql} from "@apollo/client"
export const DELETE_MEDIA = gql`
  mutation DeleteMedia($id: Int) {
    DeleteMedia(id: $id)
  }
`
